import type { FC } from 'react'
import type { CardMeta, PortConsumptionRow } from './types'
import CardInfoButton from './CardInfoButton'

const meta: CardMeta = {
  description: 'Recorded berth and anchorage fuel/hours from submitted or reviewed Daily Position Reports.',
  endpoint: 'GET /api/dpr',
  logic: 'Uses FO rows atBerthCons/atBerthHrs and atAnchorageCons/atAnchorageHrs. KL and hours stay separate. Whole-report and machinery totals are not added; each saved report row is shown separately.',
}

const formatValue = (value: number | null) => value == null ? 'Not reported' : value.toLocaleString(undefined, { maximumFractionDigits: 3 })

export const PortConsumptionTable: FC<{ rows: PortConsumptionRow[]; compact?: boolean }> = ({ rows, compact }) => (
  <div className='table-responsive'>
    <table className='table table-sm align-middle mb-0' style={{ fontSize: compact ? '10px' : '12px', minWidth: compact ? '320px' : '700px' }}>
      <thead><tr className='text-muted'>
        <th>Vessel</th>{!compact && <th>Report</th>}<th>Recorded Date</th>
        <th>Berth (KL)</th>{!compact && <th>Berth (hrs)</th>}
        <th>Anchorage (KL)</th>{!compact && <th>Anchorage (hrs)</th>}
      </tr></thead>
      <tbody>
        {rows.length === 0 ? <tr><td colSpan={compact ? 4 : 7} className='text-center text-muted py-4'>No berth or anchorage values reported in submitted/reviewed DPRs.</td></tr> : rows.map(row => <tr key={row.key}>
          <td className='fw-semibold'>{row.vessel}{compact && <div className='text-muted'>Daily Position Report · #{row.reportId}</div>}</td>
          {!compact && <td>Daily Position Report<div className='text-muted'>#{row.reportId} · {row.status}</div></td>}
          <td>{row.date || 'Not reported'}</td>
          <td>{formatValue(row.berthFuel)}{compact && <div className='text-muted'>{formatValue(row.berthHours)}{row.berthHours != null ? ' hrs' : ''}</div>}</td>
          {!compact && <td>{formatValue(row.berthHours)}</td>}
          <td>{formatValue(row.anchorageFuel)}{compact && <div className='text-muted'>{formatValue(row.anchorageHours)}{row.anchorageHours != null ? ' hrs' : ''}</div>}</td>
          {!compact && <td>{formatValue(row.anchorageHours)}</td>}
        </tr>)}
      </tbody>
    </table>
  </div>
)

const ConsumptionTable: FC<{ rows: PortConsumptionRow[]; onViewAll: () => void }> = ({ rows, onViewAll }) => (
  <div className='card flex-1' style={{ borderRadius: '16px' }}>
    <div className='card-body'>
      <div className='d-flex align-items-center gap-2 mb-3'>
        <h6 className='fw-bold text-dark mb-0' style={{ fontSize: '13px' }}>In-Port Consumption</h6>
        <span className='ms-auto d-flex align-items-center gap-2'>
          <CardInfoButton meta={meta} />
          <button type='button' className='btn btn-link p-0 fw-bold' style={{ fontSize: '10px' }} onClick={onViewAll}>View all</button>
        </span>
      </div>
      <div className='text-muted mb-2' style={{ fontSize: '11px' }}>Submitted/reviewed DPRs · reported fuel and hours</div>
      <PortConsumptionTable rows={rows.slice(0, 4)} compact />
      {rows.length > 4 && <div className='text-muted mt-2'>Showing 4 of {rows.length} saved rows.</div>}
    </div>
  </div>
)

export default ConsumptionTable
